import { createSlice } from "@reduxjs/toolkit";

const userSlice = createSlice({
    name: "user",
    initialState: {
        loggedIn: false,
        userDetails: {
            id: '',
            brokerId: null,
            firstName: '',
            lastName: '',
            email: '',
            mobileNo: '',
            countryName: '',
            isFTP: false,
            ibRequestStatus: "DidNotRequested",
            kycStatus: "NotAppliedYet",
            referralCode: null,
            userType: '',
            profilePicture: null,
            accountType: null,
        },
    },
    reducers: {
        setloggedIn: (state, action) => {
            state.loggedIn = action.payload;
        },
        setUserDetails: (state, action) => {
            state.userDetails = action.payload;
        },
    },
})

export const { setloggedIn, setUserDetails } = userSlice.actions;

export default userSlice.reducer;